import React, { FC } from 'react';
import './styles.scss';
type Props = {
  data: string;
};
const FeedImagePreviewCard: FC<Props> = ({ data }) => {
  return (
    <div className='py-1 border border-1 rounded-[10px] border-[#EDEDEE]'>
      <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>Use Image</p>
      <hr className='text-[#EDEDEE]' />
      <div className='p-6'>
        <div className='w-full md:h-[300px] sm:[100px] '>
          <img className='w-full h-full rounded-[10px] object-cover' src={data} />
        </div>
      </div>
    </div>
  );
};

export default FeedImagePreviewCard;
